


















import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";
import { CloudHelper } from "@/helper/cloudHelper";
import { DateHelper } from "@/helper/dateHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { RequestHelper } from "@/helper/requestHelper";
import { Const } from "@/const";
import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { CloudOperation } from '@/cloudOperation/cloudOperation';

import TermsOfService from "./termsOfService/termsOfService.vue";
import SignUp from "./signUp/signUp.vue";
import OnetimePass from "./onetimePass/onetimePass.vue";
import Questionnaire from "./questionnaire/questionnaire.vue";
import License from "../top2/mainContents/license/license.vue";

@Component({
  components: {
      TermsOfService,
      SignUp,
      OnetimePass,
      Questionnaire,
      License
  }
})
export default class UserRegistration extends Vue {
    isLicense = false;
    isTermsOfService = true;
    isSignUp = false;
    isOnetimePass = false;

    errorMessages = new Array();

    isError = false;

    private mounted(){
        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
    }

    private onDoCommand(command: string, param: any){
        if(command == "agree"){
            this.agree();
        }
        else if(command == "signUp"){
            this.signUp(param);
        }
        else if(command == "onetimePass"){
            this.onetimePass(param);
        }
        else if(command == "questionnaire"){
            this.questionnaire(param);
        }
        else if(command == "returnPage"){
            this.returnPage();
        }
    }

    private get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    private agree(){
        this.isTermsOfService = false;
        this.isSignUp = true;
    }

    // 新規登録
    private signUp(param){
        RequestHelper.post("sign_up", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                CookieHelper.setItem("certificationToken", res.data.certificationToken);

                this.isError = false;
                this.isSignUp = false;
                this.isOnetimePass = true;
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    // 新規登録時のワンタイムパス送信
    private onetimePass(param){
        RequestHelper.post("check_onetime", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                this.isError = false;
                this.isOnetimePass = false;
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private questionnaire(param){
        RequestHelper.post("questionnaire", param, (response) => {
            var res : any = JSON.parse(response);
            DebugHelper.trace(res);
            if(res.message.length > 0){
                this.isError = true;
                this.errorMessages = new Array();
                for(var i = 0; i < res.message.length; i++){
                    this.errorMessages.push({index: i, message: res.message[i]});
                }
            }
            else{
                CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                CookieHelper.setItem("accessToken", res.data.accessToken);
                CookieHelper.setItem("refreshToken", res.data.refreshToken);
                CookieHelper.setItem("accessLimit", res.data.accessLimit);
                CookieHelper.setItem("refreshLimit", res.data.refreshLimit);

                this.cloudAccount.isSignIn = true;
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
                CloudHelper.updateRefreshTokenTimer(this.cloudAccount);

                this.$router.push("/" + this.cloudAccount.toGo);
            }
        }, () => {
            DebugHelper.trace("エラー");
        });
    }

    private returnPage(){
        history.back();
    }

    private encodeHTMLForm(data : any){
        var params = new Array();

        for(var name in data){
            var value = data[name];
            var param = encodeURIComponent( name ) + '=' + encodeURIComponent( value );

            params.push( param );
        }
        return params.join( '&' ).replace( /%20/g, '+' );
    }

    private get cloudOperation() : CloudOperation
    {
      	return this.$store.getters.cloudOperation;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background : this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }
}
